module.exports = __webpack_public_path__ + "img/mobileCode.ec3eaa6c.jpg";